export enum OnboardingIssue {
    NotFinished = 'not_finished',
    MissingDevoId = 'missing_devo_id',
    MissingGzId = 'missing_gz_id',
    GzErrVisibility = 'gz_err_visibility',
    GzErrAccessAbove = 'gz_err_access_above',
    GzErrAccess = 'gz_err_access',
    GzErrMissingEdr = 'gz_err_missing_edr',
    GzErrGenericErr = 'gz_err_generic_err',
}

export const ReadableOnboardingIssue: { [issue in OnboardingIssue]: string } = {
    [OnboardingIssue.NotFinished]: $localize`Not finished`,
    [OnboardingIssue.MissingDevoId]: $localize`Missing DEVO ID`,
    [OnboardingIssue.MissingGzId]: $localize`Missing GZ ID`,
    [OnboardingIssue.GzErrVisibility]: $localize`Company outside Partners & Customers`,
    [OnboardingIssue.GzErrAccessAbove]: $localize`Missing "manage from above" on parent level`,
    [OnboardingIssue.GzErrAccess]: $localize`Missing "manage from above"`,
    [OnboardingIssue.GzErrMissingEdr]: $localize`EDR missing`,
    [OnboardingIssue.GzErrGenericErr]: $localize`Generic GZ error`,
};

export const OnboardingIssueDescriptions: { [issue in OnboardingIssue]: string } = {
    [OnboardingIssue.NotFinished]: $localize`Onboarding not finished.`,
    [OnboardingIssue.MissingDevoId]: $localize`Contact Support. Error MDROP-0202.`,
    [OnboardingIssue.MissingGzId]: $localize`Please activate your GravityZone license.`,
    [OnboardingIssue.GzErrVisibility]: $localize`Contact Support. Error MDROP-0201.`,
    [OnboardingIssue.GzErrAccessAbove]: $localize`Missing "manage from above" on parent level`,
    [OnboardingIssue.GzErrAccess]: $localize`Please enable Allow Management by Partner in GravityZone.`,
    [OnboardingIssue.GzErrMissingEdr]: $localize`Please install or enable EDR.`,
    [OnboardingIssue.GzErrGenericErr]: $localize`Generic GravityZone error.`,
};
